<template>
  <div class="detail"  :class="{ 'darkmode': darkMode }">
    <header class="header g_panel-header">
      <template v-if="repo">
        <div class="title">
          <a class="header-title-name " target="_blank" :href="repo.html_url">{{repo.full_name}}</a>
          <!-- <span
            class="icon-edit"
            role="button"
            aria-label="编辑分类"
            tabIndex="0">
          </span> -->
          <i  v-if="loading" class="g_loading loading-icon  icon-loading loading"></i>
        </div>
        <div class="right">
          <div v-if="repo && (repo.unStar || !repo.id)" @click="handleStar" class="edit edit_star" aria-label="edit repo category">
            <i class="g_loading  icon-loading" v-if="starLoading"></i>
            <i class="icon-star_bg" v-else></i>Star
          </div>
          <div v-else  @click="handleUnStar" class="edit edit_star" aria-label="edit repo category">
            <i class="g_loading  icon-loading" v-if="unStarLoading"></i>
            <i class="icon-star" v-else></i>Unstar
          </div>
          <div title="delete" v-if="repo && repo.unStar && this.type !== 'trend'" @click="delTrashStar" class="edit edit_trash" aria-label="edit repo category">
            <i class="g_loading  icon-loading" v-if="delLoading"></i>
            <i class="icon-trash-empty" v-else></i>
          </div>
          <a target="_blank" :href="repo.html_url" class="edit icon-external-link" aria-label="edit repo category"></a>
          <div v-if="!repo.unStar && repo.id"  class="edit icon-setting" aria-label="edit repo category" @click.stop="showStarEditPanel(repo)"></div>
        </div>
      </template>
    </header>
    <div class="toolbar" v-if="repo && repo.tagsInfos">
      <div class="tagsw">
        <div class="tag" v-for="(tag, index) in repo.tagsInfos" :key="index" :class="{tag_git : tag.type === 'github'}">
          <img class="icon" :src="tag.icon" :alt="tag.name" />
          {{tag.name}}
        </div>
      </div>
    </div>
    <div class="con g_scroll " >
      <div v-if="markdown && !loading" class="markdown-body" v-html="markdown"></div>
      <Loading v-if="isUpdating === '1' && (!stars || !Object.keys(stars).length)"  :msg="updatingText + updateTagProgress"></Loading>
      <div class="g_skeleton g_skeleton_show" v-if="loading && isUpdating !== '1'"></div>
      <div class="nostars" v-if="!markdown && !loading && isUpdating !== '1'">{{this.$t('detail.noReadme')}}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import MarkdownIt from 'markdown-it'
import Loading from '@/components/Loading'
import 'github-markdown-css'

export default {
  components: {
    Loading,
  },
  props: {
    type: String,
  },
  data() {
    return {
      loading: false,
      markdown: '',
      repo: null,
      repoId: '',
      unStarLoading: false,
      starLoading: false,
      delLoading: false,
      repoChange: false,
      updatingText: this.$t('detail.updatingText'),
      md: null,
    }
  },
  watch: {
    $route(val) {
      if (val.query.repo) {
        this.init()
      }
    },
    stars(val) {
      if (val && this.tags) {
        this.init()
        console.log('stars change')
      }
    },
    tags(val) {
      if (val && this.stars) {
        this.init()
      }
    },
    delStars(val) {
      if (val && this.$route.id === 'trash') {
        this.init()
      }
    },
    showEditHotkey(newVal, oldVal) {
      this.$hotkeys.unbind(oldVal)
      this.initHotKey()
    },
  },
  computed: {
    ...mapState({
      accessToken: state => state.user.accessToken,
      updateTagProgress: state => state.star.updateTagProgress,
      isUpdating: state => state.star.isUpdating,
      stars: state => state.star.stars,
      tags: state => state.star.tags,
      delStars: state => state.star.delStars,
      showEditHotkey: state => state.event.showEdit,
    }),
  },
  mounted() {
    this.init()
    this.initHotKey()
    this.md = new MarkdownIt({
      html: true,
      linkify: true,
      typographer: true,
    })
    this.$on('refresh', this.initTags)
    this.$on('trendshow', this.initTrendDetail)
  },
  beforeDestroy() {
    this.$hotkeys.unbind(this.showEditHotkey)
  },
  methods: {
    ...mapMutations({
      changeUpdateStatus: 'star/changeUpdateStatus',
      showStarEditPanel: 'starEdit/togglePanel',
      setBroadcast: 'setBroadcast',
    }),
    ...mapActions({
      unStar: 'star/unStar',
      getRepoInfo: 'star/getRepoInfo',
      newStar: 'star/newStar',
      delTrashStarAction: 'star/delTrashStars',
    }),
    initHotKey() {
      this.$hotkeys(this.showEditHotkey, (e) => {
        e.preventDefault()
        this.showStarEditPanel(this.repo)
        console.log('command+shift+e')
      })
    },
    async init() {
      // trending页面下的不做初始化
      if (this.type === 'trend') return

      if (!this.stars) return
      this.initTags()
      if (!this.repo) return

      await this.getReadMe()
      this.repoChange = false
    },
    beforeDestroy() {
      this.$hotkeys.unbind('command+shift+space')
    },
    /**
     * trending页面下的初始化
     */
    initTrendDetail(star) {
      if (!star.full_name) star.full_name = star.author + '/' + star.reponame
      if (!this.repo || star.full_name !== this.repo.full_name) {
        this.repoChange = true
      }
      this.repo = star

      if (!star.id) {
        this.repo.unStar = true
        this.getRepoInfo(this.repo.full_name).then((res) => {
          this.repo = res
          this.repo.unStar = true
        })
        this.getReadMe()
      } else {
        // this.initTags()
        this.getReadMe()
      }
    },
    /**
     * 删除垃圾桶的stars
     */
    delTrashStar() {
      const ids = [this.repo.id]
      this.$toast({
        msg: this.$t('starsPanel.delConfirm', { name: this.repo.name }),
        isConfirm: true,
      }).then(() => {
        this.delLoading = true

        this.delTrashStarAction({
          ids,
        }).then((res) => {
          this.$toast({
            msg: this.$i18n.t('starsPanel.delTrashStar'),
          })

          this.setBroadcast({
            type: 'starChange',
          })
          this.repo = null
          this.markdown = ''
          this.delLoading = false
        })
      })
    },
    handleUnStar() {
      this.$toast({
        msg: this.$t('starsPanel.unstarConfirm', { name: this.repo.name }),
        isConfirm: true,
      }).then(() => {
        this.unStarLoading = true

        this.unStar([this.repo]).then(() => {
          this.$toast({
            msg: this.$i18n.t('starsPanel.unStarTip'),
          })
        }).catch((err) => {
          this.unStarLoading = false
          if (err && err.type === 'github') {
            this.$router.push({
              name: 'setting',
            })
            if (err.message === 'Not Found') {
              err.message = this.$t('accessToken.errTip_404')
            }
            this.$toast({
              msg: (err.message ? err.message + ', ' : '') + this.$t('accessToken.errTip'),
              isConfirm: true,
            })
          }
        }).finally(() => {
          this.unStarLoading = false
        })
      })
    },
    async handleStar() {
      // this.$toast({
      //   msg: this.$t('starsPanel.starConfirm', { name: this.repo.name }),
      //   isConfirm: true,
      // }).then(async () => {
      this.starLoading = true
      if (!this.repo.id) {
        this.repo = await this.getRepoInfo(this.repo.full_name)
        this.repo.unStar = true
      }
      this.newStar({
        stars: [this.repo],
      }).then(() => {
        this.starLoading = false
        this.showStarEditPanel(this.repo)
      }).catch((err) => {
        this.starLoading = false
        if (err && err.type === 'github') {
          this.$router.push({
            name: 'setting',
          })
          if (err.message === 'Not Found') {
            err.message = this.$t('accessToken.errTip_404')
          }
          this.$toast({
            msg: (err.message ? err.message + ', ' : '') + this.$t('accessToken.errTip'),
            isConfirm: true,
          })
        }
      })
      // })
    },
    getReadMe() {
      if (!this.repoChange) return
      this.loading = true
      // this.$http.get(`/star/${this.repo.full_name}/readme`, {
      this.$http.get(`https://wk.littlestarcloud.com/repos/${this.repo.full_name}/readme`, {
      }, {
        noCsrfToken: true,
        noHandler: true,
        headers: {
          authorization: this.accessToken ? `token ${this.accessToken}` : undefined,
          Accept: 'application/vnd.github.VERSION.html',
        },
      }).then((res) => {
        // this.markdown = res.replace(/(<img[^>]+src=")(?!http(s)?:\/\/)([^"]+?(?="))/gi, `$1https://raw.githubusercontent.com/${this.repo.full_name}/master/$3`)
        const markdown = res
        // if (res.origin === 'github') {
        //   markdown = res.data && res.data.data && res.data.data.content ? decodeURIComponent(escape(window.atob(res.data.data.content))) : ''
        // } else {
        //   markdown = res.data
        // }
        this.markdown = markdown.replace(/(<img[^>]+src=")(?!http(s)?:\/\/)([^"]+?(?="))/gi, `$1https://raw.githubusercontent.com/${this.repo.full_name}/master/$3`)
        this.markdown = this.markdown.replace(/(<a)([^>]+href=")(?!http(s)?:\/\/)(#[^"]+?(?="))/gi, `$1$2https://github.com/${this.repo.full_name}/$4`)
        this.markdown = this.markdown.replace(/(<a)([^>]+href=")(?![(http(s)?://)|#])([^"]+?(?="))/gi, `$1$2https://github.com/${this.repo.full_name}/blob/master/$3`)
        this.markdown = this.markdown.replace(/(<a)([^>]+href=")/gi, '$1 target=\'_blank\' $2')
        this.$forceUpdate()
        this.loading = false
      }).catch((err) => {
        if (err && err.status === 404) {
          this.markdown = ''
          this.loading = false
          this.$forceUpdate()
        } else if (err && err.status === 401) {
          this.$toast({
            msg: (err.message ? err.message + ', ' : '') + this.$t('accessToken.errTip'),
            isConfirm: true,
          }).then(() => {
            this.$router.push({
              name: 'setting',
            })
          })
          this.loading = false
        } else {
          this.$http.get(`/star/${this.repo.full_name}/readme`).then((res) => {
            let markdown
            if (res.origin === 'github') {
              markdown = res.data && res.data.data && res.data.data.content ? decodeURIComponent(escape(window.atob(res.data.data.content))) : ''
            } else {
              markdown = res.data
            }
            this.markdown = this.md.render(markdown)
            this.markdown = this.markdown.replace(/(<img[^>]+src=")(?!http(s)?:\/\/)([^"]+?(?="))/gi, `$1https://raw.githubusercontent.com/${this.repo.full_name}/master/$3`)
            this.markdown = this.markdown.replace(/(<a)([^>]+href=")(?!http(s)?:\/\/)(#[^"]+?(?="))/gi, `$1$2https://github.com/${this.repo.full_name}/$4`)
            this.markdown = this.markdown.replace(/(<a)([^>]+href=")(?![(http(s)?://)|#])([^"]+?(?="))/gi, `$1$2https://github.com/${this.repo.full_name}/blob/master/$3`)
            this.markdown = this.markdown.replace(/(<a)([^>]+href=")/gi, '$1 target=\'_blank\' $2')
            this.$forceUpdate()
          }).catch((err) => {
            this.loading = false
            this.$toast({
              msg: err.msg || '服务器出问题',
              isConfirm: true,
            })
          })
        }
      })
    },
    initTags() {
      if (!this.stars || !this.tags) return

      let repoId = this.$route.query.repo

      if (!this.repo || repoId + '' !== this.repo.id + '') {
        this.repoChange = true
      }
      // get repo
      if (!repoId && this.stars) {
        const keys = Object.keys(this.stars)
        repoId = keys[0]
      }
      this.repo = this.stars[repoId]
      if (!this.repo) return
      // tags
      const tags = this.repo.tags
        ? this.tags.filter((item) => this.repo.tags.indexOf(item._id) !== -1)
        : []
      this.repo.tagsInfos = tags.sort((item1, item2) => {
        if (item1.type === 'github' && item2.type !== 'github') {
          return -1
        }
        if (item1.type !== 'github' && item2.type === 'github') {
          return 1
        }
        return 0
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/scss/animation.scss';

.detail{
  display: flex;
  flex-direction: column;
}
.header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  box-shadow: none;
  .title{
    font-size: 20px;
    font-weight: bold;
    width: 50%;
  }
  .loading{
    color: #D8D8D8;
    font-size: 22px;
    margin-left: 16px;
    &:before{
      animation: spin 1s infinite linear;
    }
  }
  .header-title-name{
    font-weight: bold;
    color: #3C3D3C;
    text-decoration: none;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 52px;
    &:hover{
      color: #3582fb;
      text-decoration: underline;
    }
  }
  .icon-edit{
    line-height: 52px;
    color:#C6C4C4;
    cursor: pointer;
    transition: color 0.2s ease;
    position: relative;
    user-select: none;
    font-size: 14px;
    margin-left: 8px;
    &:hover{
      color: #5D5D5D;
    }
  }
}

  .right{
    display: flex;
    align-items: center;
  }
  .edit{
    display: block;
    /* Rectangle 29 */

    background-image: linear-gradient(180deg,#fdfdfd 4%,#f0f0f0);
    // box-shadow: 0 0 1px 0 rgba(194,194,194,0.50);
    border-radius: 4px;
    height: 32px;
    min-width: 32px;
    line-height: 30px;
    border-radius: 999px;
    padding: 0 8px;
    margin-left: 4px;
    text-align: center;
    color: #5d5d5d;
    box-sizing: border-box;
    border:1px solid #dcdcdc;
    // border-top: 1px solid rgba(214, 214, 214, 0.5);
    // border: 2px solid #EDEDED;
    cursor: pointer;
    &:hover{
      color: #fff;
      .icon-star{
        color: #fff;
      }
      background: linear-gradient(180deg, #3785FF 0%, #1470FF 100%);
    }
    .icon-star_bg,
    .icon-star{
      font-size: 18px;
      vertical-align: -1px;
      margin-right: 2px;
      // color: #ff9900;
    }
  }
  .edit_star{
    font-size: 12px;
    font-weight: bold;
    text-decoration: none;
  }
  .edit_trash{
    font-size: 14px;
  }
.toolbar{
  height: 40px;
  background: #EDEDED;
  background: linear-gradient(180deg, #F9F9F9 3.73%, #F8F8F8 128.97%);
  // box-shadow: 0px 0.5px 0px rgba(155, 155, 155, 0.5);
  // position: relative;
  // z-index: 1;
  border-top: 1px solid rgba(214, 214, 214, 0.5);
  display: flex;
  align-items: center;
  // position: relative;
  justify-content: space-between;
  // justify-content: flex-end;
}
.tagsw{
  margin-right: 28px;
  border-radius: 4px;
  display: flex;
  padding: 0px;
  border-radius: 4px;
  margin-left: 18px;
  .icon{
    height: 15px;
    width: 15px;
    margin-right: 5px;
    vertical-align: middle;
  }
  .tag{/* Rectangle 27 */
    border: 1px solid rgba(125, 134, 138, 0.2);
    border-radius: 8px;
    display: flex;
    padding: 0 7px;
    line-height: 28px;
    height: 28px;
    font-size: 12px;
    text-align: center;
    align-items: center;
    margin-left: 6px;
    color: #5D5D5D;
    box-sizing: border-box;
    background-color: #eff3f6;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    background-image: linear-gradient(180deg, #FDFDFD 4%, #F0F0F0 100%);
  }
  .tag_git{
    padding: 0 7px;
    font-size: 12px;
    text-align: center;
    background-image: linear-gradient(-180deg, rgb(255, 255, 255) 4%, rgb(245, 245, 245));
  }
}
.con{
  position: relative;
  flex: 1 1 auto;
  height: calc(100vh - 52px);
  padding: 10px 30px 60px;
  box-sizing: border-box;
  // border-top: 1px solid rgba(195, 195, 195, 0.5);
  border-top: 1px solid rgba(214, 214, 214, 0.5);
  transition: opacity 0.5s ease;
  .loading{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto!important;
  }
  .nostars{
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #DCDCDC;
    font-size: 38px;
    margin: auto;
    background: #fff;
  }
}
.con_loading{
  opacity: 0.5;
}

// darkmode
.darkmode{
  .header{
    background-image: linear-gradient(180deg, #464543 5%, #3C3B39 99%);
    box-shadow: 0 0.5px 0 0 rgba(32, 32, 32, 0.5);
  }
  .toolbar{
    background: rgba(67, 67, 67, 0.33);
    color: #848484;
    box-shadow: none;
    border-top-color: #2d2d2d;
    border-bottom: 1px solid #252525;
  }
  .toolbar,
  .header{
    .edit, .tag{
      border: 1px solid #2F2F2F;
      background-image: linear-gradient(180deg, #525252 4%, #454545 100%);
      color: #fff;
      background-color: unset;
    }
    .edit:hover{
      background-image: linear-gradient(180deg, #787878 4%, #6c6c6c 100%);
    }
  }
  .header-title-name{
    color: #fff;
  }
  .con{
    border-top:none;
    background: #1B1B1B;
  }
  .nostars{
    background: #1B1B1B;
  }
  /deep/ .markdown-body{
    padding-bottom: 100px;
    background: #1B1B1B;
    color: #fff;
    border-top-color: #393939;
    a {
      color: #61AFEF;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-weight: 600;
      color: #E06C75;
    }
    pre  {
    }
    pre ul, pre li, pre p{
      margin-top: 0;
      margin-bottom: 0;
      line-height: 1;
    }
    code {
      color: #90C378;
    }

    pre:not(.hljs),
    code>div {
      color: #cfd4de;
      background-color: #2C323C;
    }

    table>tr>td,
    table>thead>tr>th {
      border-color: #41454c;
      background-color: #2C323C;
    }
    table tbody td,
    table tbody tr{
      border-color: #41454c;
      background-color: #2C323C;
    }
    h1,
    hr,
    table>tbody>tr+tr>td {
      border-color: #41454c;
    }
    .markdown-body .pl-ent{
      color: #97e1a9;
    }
    .markdown-body .pl-s .pl-s1, .markdown-body .pl-smi{
      color: #c79393;
    }
    .markdown-body .pl-pds, .markdown-body .pl-s, .markdown-body .pl-s .pl-pse .pl-s1, .markdown-body .pl-sr, .markdown-body .pl-sr .pl-cce, .markdown-body .pl-sr .pl-sra, .markdown-body .pl-sr .pl-sre{
      color:#e06c75;
    }
    .markdown-body .pl-c1, .markdown-body .pl-s .pl-v{
      color:#e8e8e8;
    }
    blockquote {
      color: #5C6370;
      font-style: italic;
      background: transparent;
      border-color: #2C323C;
    }
  }
}
</style>

<style lang="scss">
.markdown-body{
  // background: #fafafaa2;
  // background-image: linear-gradient(-180deg, rgba(251, 251, 251, 0.09) 0%, #F1F1F1 100%);
  pre code {
    white-space: pre-wrap;
    word-break: break-word;
  }
  pre{
    word-break: break-word!important;
    white-space: pre-wrap;
  }
  pre ul, pre li, pre p{
      margin-top: 0;
      margin-bottom: 0;
      line-height: 1;
    }
}
</style>
